import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { PlanList } from './PlanList';

export const PlanListPage = () => {
  useTitle('Список планов');

  return (
    <Layout withFooter>
      <PlanList />
    </Layout>
  );
};
